module.exports = __webpack_public_path__ + "static/city-defense-tile-9617287e798a51a7e4bf4897af11cc3e.jpg";